import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    fontWeight: 400,
    textTransform: 'none',
    textDecoration: 'underline',
    padding: 0,
    minWidth: 'unset',
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
  },
}))

export default useStyles
